<template>
  <div class="row align-items-baseline">
    <div class="col">
      <FormLabel label-is-fake :hide-label="hideLabel">{{ label }}</FormLabel>
    </div>

    <div class="col-12">
      <template v-if="cleanedTotal === 0">
        <AlertFeedback status="warning">
          Totale non specificato
        </AlertFeedback>
      </template>
      <div v-else class="d-flex flex-row justify-content-between align-items-center">
        <AwlTable :heading="headings" :rows="value" hide-header>
          <template #column-key-month="{ value, rowNumber }">
            <FormInputMonthPickerWidget
              label="Mese"
              hide-label
              :value="value"
              @input="updateMonthInMonth(rowNumber, $event)"
            />
          </template>

          <template #column-key-amount="{ row, value, rowNumber }">
            <template v-if="!row.month">-</template>
            <template v-else>
              <FormInputText type="number" :min="1" :step="1" :value="value" @input="updateAmountInMonth(rowNumber, $event)" />
            </template>
          </template>

          <template #actions-content="{ rowNumber }">
            <ActionDelete :show-icons-only="true" @click="removeMonth(rowNumber)" />
          </template>
        </AwlTable>
        <button class="btn btn-outline-primary" type="button" :disabled="totalRemaining <= 0" @click.prevent="addMonth">Aggiungi pagamento</button>
      </div>
    </div>
  </div>
</template>

<script>

import { nextYearMonth } from '@/helpers/months';
import formatMoney from '@/filters/formatMoney';

export default {
  components: {
    FormLabel: () => import('@/libs/Form/components/FormLabel'),
    AwlTable: () => import('@/libs/Table/components/AwlTable'),
    ActionDelete: () => import('@/views/components/Actions/ActionDelete'),
    FormInputMonthPickerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputMonthPickerWidget'),
    FormInputText: () => import('@/libs/Form/components/Inputs/FormInputText'),
    AlertFeedback: () => import('@/libs/Feedback/components/Alert'),
  },
  filters: {
    money: formatMoney,
  },
  props: {
    label: {
      type: String,
      default: 'Scadenzario',
    },
    hideLabel: {
      type: Boolean,
      default: true,
    },
    total: {
      default: 0,
    },
    value: {
      type: Array,
      default: () => [],
    },
    firstMonth: {},
  },
  computed: {
    cleanedTotal () {
      return parseInt(this.total || 0);
    },
    valueTotal () {
      return this.value.reduce((t, v) => t + v.amount, 0);
    },
    totalRemaining () {
      return this.cleanedTotal - this.valueTotal;
    },
    headings () {
      return [
        { key: 'month', label: 'Mese' },
        { key: 'amount', label: 'Importo' },
      ];
    },
  },
  methods: {
    emitValue (newValue) {
      this.$emit('input', newValue.filter((value, index, self) => self.findIndex(v => v.month === value.month) === index).sort((a, b) => {
        if (a.month === b.month) {
          return 0;
        }

        if (!a.month) {
          return 1;
        }

        if (!b.month) {
          return -1;
        }

        return a.month < b.month ? -1 : 1;
      }));
    },
    addMonth () {
      const newValue = [...this.value];

      let month = null;
      if (newValue.length === 0) {
        month = nextYearMonth(this.firstMonth);
      }

      let amount = 0;
      if (month && newValue.length === 0) {
        amount = Math.max(0, this.totalRemaining);
      }

      newValue.push({
        month: month,
        amount: amount,
      });

      this.emitValue(newValue);
    },
    removeMonth (rowNumber) {
      this.emitValue((this.value || []).filter((r, i) => i !== rowNumber));
    },
    updateAmountInMonth (rowNumber, value) {
      this.emitValue((this.value || []).map((r, i) => {
        if (i === rowNumber) {
          r.amount = parseInt(value) || 0;
        }

        return r;
      }));
    },
    updateMonthInMonth (rowNumber, value) {
      this.emitValue((this.value || []).map((r, i) => {
        if (i === rowNumber) {
          r.month = value;

          if (!r.month) {
            r.amount = 0;
          } else if (!r.amount) {
            r.amount = Math.max(0, this.totalRemaining);
          }
        }

        return r;
      }));
    },
  },
};

</script>
